import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import BulletinApi from '../api/BulletinApi';
import {BulletinsActionType, changeBulletins, getBulletins} from '../ducks/Bulletin';
import {Bulletin} from '../models/Bulletin';

export function* getBulletinsFromApi(action: ReturnType<typeof getBulletins>) {
    const {pageOption, filter, sort} = action.payload;
    if (pageOption) {
        yield put(changeBulletins(new LoadingAdditional(pageOption)));
    } else {
        yield put(changeBulletins(new Loading(pageOption)));
    }

    const result: AsyncResult<Page<Bulletin>> = yield pageOption
                                                      ? call(mergeWithNextPage, {existingPage: pageOption})
                                                      : call(BulletinApi.getBulletins, filter, sort, action.payload.isNewYork);

    yield pipe(
        result,
        E.map(fromResult),
        E.fold(
            value => put(changeBulletins(value)),
            value => put(changeBulletins(value))
        )
    );
}

export function* fetchBulletinsSaga() {
    yield takeLatest(BulletinsActionType.GET_BULLETINS, getBulletinsFromApi);
}

export default function* () {
    yield all([fetchBulletinsSaga()]);
}

